module.exports = __webpack_public_path__ + "static/media/map.21051bfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/map.svg
// module id = 1152
// module chunks = 0